/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

import { useResponsive } from 'handimap-react-lib/hooks/useResponsive';
import { FontAwesomeSvgIcon } from 'handimap-react-lib/components/FontAwesomeSvgIcon';
import { showLegends } from 'handimap-react-lib/store/actions/legendActions';
import { LegendItems } from 'handimap-react-lib/components/LegendItems';

export const LegendContainer = ({allResults, status}) => {

  const { isMobile } = useResponsive();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const layerConf = useSelector(state => state.layerConf);
  const layerList = layerConf.buttonsLayersState;
  const {list, show} = useSelector(state => state.legendList);
  const baseGraphShown = useSelector(state => state.map.showBaseGraphe);

  const [layerVisibleList, setLayerVisibleList] = useState([]);

  useEffect(() => {
    setLayerVisibleList([]);
    let newList = [];
    for (const key in layerList) {
      if (layerList[key].active === true) {
        newList.push(layerList[key]);
      }
    }
    setLayerVisibleList(newList);
  }, [layerConf]);

  const styles = {
    container: {
      width: isMobile ? '100vw' : 300,
      height: isMobile ? '100vh' : 400,
      zIndex: 1000,
      backgroundColor: 'white',
      opacity: isMobile ? 1 : 0.9,
      padding: '.5em',
      pointerEvents: 'auto'
    },
    contentContainer: {
      display: 'flex', 
      width: '100%'
    },
    list: {
      maxHeight: isMobile ? null : 330, 
      minWidth: 300, 
      overflow: 'auto',
      '&::-webkit-scrollbar': {
        width: '4px'
      },
      '&::-webkit-scrollbar-track': {
        width: '2px',
      },
      '&::-webkit-scrollbar-thumb': {
        borderRadius: '0.5em',
        backgroundColor: 'gray'
      },
    }
  };

  return (
    <Box sx={styles.container}>
      <Stack sx={styles.contentContainer} direction='column' spacing={1}>
        <Box sx={{ display: 'flex', width: '100%' }}>
          <Box sx={{ display: 'flex', width: '90%' }}>
            <Typography sx={{ mt: 1, ml: 2}} color='primary' variant="h6" component="div">
              {t('legend.title')}
            </Typography>
          </Box>
          <Box sx={{ mt: 1, display: 'flex' }}>
            <Button aria-label={t('legend.close')} variant='text' onClick={() => dispatch(showLegends(false))}>
              <FontAwesomeSvgIcon icon={faTimes} />
            </Button>
          </Box>
        </Box>
        <Box sx={{ display: 'flex', width: '100%' }}>
          <Grid item>
            <List 
              sx={styles.list}
              dense={true}
            >
              {baseGraphShown ? (
                <>
                  {list.map((legend, index) => {
                    return (
                      <LegendItems  key={index} nameAcc={legend} />
                    );
                  })}
                </>
              ) : (
                <>
                  {status === 'success' && allResults.length > 0 && 
                   (
                     <>
                       {list.map((legend, index) => {
                         return (
                           <LegendItems  key={index} nameAcc={legend} />
                         );
                       })}
                     </>
                   )
                  }
                </>
              )}
              {layerVisibleList.map((layerInfos) => {
                return layerInfos.legendIcons.map((pngIcon, index) => {
                  return (
                    <ListItem key={pngIcon}>
                      <ListItemAvatar>
                        <img src={pngIcon} width="30px" height="30px"/>
                      </ListItemAvatar>
                      <ListItemText
                        primary={layerInfos.legendLabels[index]}
                        disableTypography={true}
                      />
                    </ListItem>
                  );
                });
              }
              )}
            </List>
          </Grid>
        </Box>
      </Stack>
    </Box>
  );
};